
import React, { Component } from 'react';

import { Navbar, Nav, NavItem, NavLink } from 'reactstrap';
import { LargeBusiness } from '../Constants';

class TopNav extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isBusinessSite: location.href.indexOf("/business/") > 0,
    };
  }

  render() {
    const { props } = this.props;
    const telephoneNo = props &&
      props.secondaryNavRight &&
      props.secondaryNavRight.children[0] &&
      props.secondaryNavRight.children[0].link &&
      props.secondaryNavRight.children[0].link.title;
    const containerName = LargeBusiness.isLBSite ? "lb-topnav-container" : ""
    return (
      <div className={`${containerName}`}>
        <Navbar className="topnav p-md-0 navbar-expand ">
          <div className="container">
            <Nav className="navbar-nav list-inline" navbar >
              {props.secondaryNavLeft.children.map((item, index) => {
                return (
                  <NavItem key={index} className="d-none d-md-block p-0">
                    <NavLink className="eir-top-nav-link p-0 position-relative text-left" href={item.link.link} aria-label={item.link.ariaLabel || undefined}>
                      {item.link.title}
                    </NavLink>
                  </NavItem>
                )
              })}
            </Nav>
            {/* {!this.state.isBusinessSite && */}
            <Nav className="navbar-nav list-inline" navbar >
              {props.secondaryNavRight.children.map((item, index) => {
                if (item.icon === undefined) {
                  if (item.link && item.link.text.startsWith('phoneno')) {
                    return (
                      <NavItem key={index} className="p-0 pl-4 pl-lg-5">
                      <div id = "top-nav-phonenumber"></div>
                        {/* To display on desktop */}
                        <NavLink style={{ textDecoration: 'none' }} className="eir-top-nav-link-desktop position-relative text-right">
                          {item.link.title}
                        </NavLink>
                        {/* To display on mobile  */}
                        <NavLink href={`tel:${telephoneNo}`} className="eir-top-nav-link-mobile position-relative text-right">
                          {item.link.title}
                        </NavLink>
                      </NavItem>
                    )
                  }
                  else {
                    return (
                      <NavItem key={index} className="p-0 pl-4 pl-lg-5">
                          <NavLink className="eir-top-nav-link position-relative text-right" href={item.link.link}>
                          {item.link.title}
                        </NavLink>
                      </NavItem>
                    )
                  }
                }
                else {
                  // eir-1086
                  return (
                    <NavItem key={index} className="p-0 pl-4 pl-lg-3">                       
                      <NavLink className='eir-top-nav-link position-relative p-0 text-right top-right-item' aria-label={item.link.ariaLabel || undefined}  href={item.link.link} target={(item.link.target) ? '_blank' : ''}>
                        <div className={'eir-icon d-none d-lg-inline-flex icon-' + item.icon + '--black'} />
                        {item.link.title}
                      </NavLink>                      
                    </NavItem>
                  )
                }
              })}
            </Nav>
            {/* } */}
          </div>
        </Navbar>
      </div>
    );
  }
}

export default TopNav;
